import { MAP_TYPE } from 'wix-rich-content-common';
export default function mapStrategy() {
    var _a;
    return {
        config: (_a = {},
            _a[MAP_TYPE] = {
                googleMapApiKey: 'AIzaSyC128nl2QIfKdqdQvo3iDo6PKSz_DV4ygI',
            },
            _a),
    };
}
//# sourceMappingURL=mapStrategy.js.map